export const CREDENTIAL = {
  // Colors
  COLOR_ERROR: '#B00020',
  COLOR_GREY: '#868686',

  // Labels
  CREDENTIAL_LABEL_TEXT: 'Type in a name or label for this credential e.g. Work Email',
  PASSWORD_LABEL_TEXT: 'Your password will be securely stored as a secret',
  SEND_TEST_EMAIL_LABEL_TEXT:
    'Send a test email to the email below to test that this SMTP credential is working',
  EMAIL_DISPLAY_NAME_LABEL_TEXT: "This name will be displayed in the 'From' field",

  // Tooltips
  EMAIL_TOOLTIP: 'Enter your email address',
  EMAIL_DISPLAY_NAME_TOOLTIP: 'Enter Email Display Name',
  HOST_TOOLTIP: 'Select your email host or choose Other to set it manually',
  PASSWORD_TOOLTIP:
    'Enter the password to your email account. This will be securely stored as a secret.',
  PORT_TOOLTIP:
    'Check with your email server but typically 25 if no encryption, 587 for TLS, 465 for SSL',
  SEND_TEST_EMAIL_TOOLTIP: 'Send a test email to check whether your SMTP settings are working',
  SSL_TOOLTIP: 'Turn on to use SSL encryption',
  TLS_TOOLTIP: 'Turn on to use TLS encryption (recommended)',
  USERNAME_TOOLTIP: 'Enter your email address again if you do not have a separate username',
  TOOLTIP_PLACEMENT: 'right',
  SMTP_SERVER_TOOLTIP: 'Enter your SMTP server address',

  // Error Messages
  ERROR_MSG_PASSWORD_EMPTY: 'This field cannot be empty',

  // Options
  SSL_OPTION: 'SSL',
  TLS_DEFAULT: 'TLS (Default)',
  SELECT_AN_OPTION: 'select an option',

  // Permissions
  PERMISSIONS_DEFAULT: [{ scope: 'GLOBAL', workflowId: '', componentId: '' }],

  // Status
  STATUS: {
    ERROR: 'error',
    SUCCESS: 'success',
  },

  // Messages
  MESSAGES: {
    CREDENTIAL_DELETED: 'Credential is deleted',
    CREDENTIAL_DELETE_FAILED: 'Credential delete failed!',
    CREDENTIAL_RELOGIN_FAILED: 'Credential re-login failed!',
    CREDENTIAL_SAVED: 'Credential is saved',
    CREDENTIAL_UPDATED: 'Credential is updated',
    TEST_EMAIL_ERROR: 'Enter an email to send a test',
    TEST_EMAIL_SENT: 'Test email sent',
    EMPTY_FIELD: 'This field cannot be empty',
    SECRET_STORAGE: 'This value is stored as a secret and cannot be viewed once saved',
    PLACEHOLDER_INSTRUCTION: 'Set the placeholder for referencing this credential',
    SECRET_INSTRUCTION:
      'This value will be securely stored as a secret and cannot be viewed after the credential has been saved',
  },

  IMPLEMENTED_INTEGRATIONS: [
    'ActiveCampaign',
    'Airtable',
    'Amplitude',
    'Anthropic',
    'Apollo',
    'Asana',
    'BambooHR',
    'Brex',
    'Cal.com',
    'Calendly',
    'ClickUp',
    'Confluence',
    'Datadog',
    'Discord',
    'Firecrawl',
    'GitHub',
    'GitLab',
    'Groq',
    'HubSpot',
    'Intercom',
    'Jira',
    'Klaviyo',
    'Linear',
    'Loops',
    'Mailchimp',
    'Mistral AI',
    'Mixpanel',
    'Monday.com',
    'Notion (API Key)',
    'Notion',
    'OpenAI',
    'Paddle',
    'PagerDuty',
    'Perplexity',
    'Pipedream',
    'Pipedrive',
    'Postmark',
    'Slack',
    'Segment',
    'SendGrid',
    'Stripe',
    'Trello',
    'Twilio',
    'Typeform',
    'WhatsApp',
    'Zendesk',
    'Airtable (API Key)',
    'Google Apps',
  ],

  INFO_DIALOGUE_STATUS: {
    NEW: 'new',
    DETAILS: 'details',
  },

  SCOPES: {
    GLOBAL: 'GLOBAL',
    WORKFLOW: 'WORKFLOW',
    COMPONENT: 'COMPONENT',
  },

  FIELD_KEYS: {
    NAME: 'name',
    DESCRIPTION: 'description',
    PLACEHOLDER: 'placeholder',
    SECRET_VALUE: 'secretValue',
    PERMISSIONS: 'permissions',
    CLIENT_ID: 'clientId',
    CLIENT_SECRET: 'clientSecret',
    AUTHORIZATION_URL: 'authorizationUrl',
    TOKEN_URL: 'tokenUrl',
    SCOPE: 'scope',
    REDIRECT_URL: 'redirectUrl',
    REFRESH_TOKEN_URL: 'refreshTokenUrl',
    REFRESH_AFTER: 'refreshAfter',
    PKCE_METHOD: 'pkceMethod',
    OAUTH_INSTALL_SCREEN_URL: 'oauthInstallScreenUrl',
    ACCESS_TOKEN: 'accessToken',
    REFRESH_TOKEN: 'refreshToken',
    TOKEN_TYPE: 'tokenType',
    EXPIRES_IN: 'expiresIn',
    GRANT_TYPE: 'grantType',
    AUTH_STATE: 'authState',
    ACCESS_TOKEN_URL: 'accessTokenUrl',
  },

  LABELS: {
    DISPLAY_NAME: 'Display Name',
    DESCRIPTION: 'Description',
    PLACEHOLDER: 'Placeholder',
    VALUE: 'Value',
    CLIENT_ID: 'Client ID',
    CLIENT_SECRET: 'Client Secret',
    AUTHORIZATION_URL: 'Authorization URL',
    TOKEN_URL: 'Token URL',
    SCOPE: 'Scopes',
    REDIRECT_URL: 'Redirect URL',
    REFRESH_TOKEN: 'Refresh Token',
    REFRESH_TOKEN_URL: 'Refresh token URL',
    REFRESH_AFTER: 'Refresh after (ms)',
    PKCE_CHALLENGE_METHOD: 'PKCE challenge method',
    OAUTH_INSTALL_SCREEN_URL: 'OAuth Install Screen URL',
    ACCESS_TOKEN: 'Access Token',
    TOKEN_TYPE: 'Token Type',
    EXPIRES_IN: 'Expires In (seconds)',
    AUTH_STATE: 'State',
    GRANT_TYPE: 'Grant Type',
    ACCESS_TOKEN_URL: 'Access Token URL',
  },

  PLACEHOLDERS: {
    DISPLAY_NAME: 'Type in a display name for this credential',
    DESCRIPTION: 'Type in a description for this credential',
    PLACEHOLDER: 'placeholder',
    SECRET_VALUE: '**********',
    CLIENT_ID: 'Enter your OAuth2 Client ID',
    CLIENT_SECRET: 'Enter your OAuth2 Client Secret',
    AUTHORIZATION_URL: 'Enter the OAuth2 Authorization URL',
    TOKEN_URL: 'Enter the OAuth2 Token URL',
    SCOPE: 'Enter the OAuth2 scopes (space-separated)',
    REDIRECT_URL: 'Enter the OAuth2 Redirect URL',
    REFRESH_TOKEN_URL: 'Enter the OAuth2 Refresh token URL',
    REFRESH_AFTER: 'Enter refresh time in milliseconds',
    OAUTH_INSTALL_SCREEN_URL: 'Enter the OAuth Install Screen URL',
    ACCESS_TOKEN: 'Your access token will appear here',
    CREDENTIAL_NAME: 'smtp.email.com',
    EMAIL: 'e.g. email@email.com',
    EMAIL_DISPLAY_NAME: 'e.g. John Smith',
    PASSWORD: '****************',
    SMTP_SERVER: 'e.g. smtp.email.com',
    TEST_EMAIL: 'e.g. email@email.com',
    REFRESH_TOKEN: 'Enter the OAuth2 Refresh Token',
    TOKEN_TYPE: 'Enter the OAuth2 Token Type',
    EXPIRES_IN: 'Enter the token expiration time in seconds',
    AUTH_STATE: 'Enter the OAuth2 Auth State',
    GRANT_TYPE: 'Select the OAuth2 Grant Type',
  },

  CREDENTIAL_TYPE: {
    SMTP: 'SMTP',
    VARIABLE: 'VARIABLE',
    INTEGRATION: 'INTEGRATION',
    OAUTH2: 'OAUTH2',
    PIPEDREAM_TRIGGER: 'PIPEDREAM_TRIGGER',
  },

  CREDENTIAL_STATUS: {
    CONNECTED: 'CONNECTED',
    DISCONNECTED: 'DISCONNECTED',
  },

  INSTRUCTIONS: {
    CLIENT_SECRET: 'Enter your OAuth2 Client Secret',
    OAUTH_INSTALL_SCREEN_URL:
      'The URL provided by your app which opens a screen for you to authorize or consent to installing the app',
  },

  PKCE_METHODS: {
    NONE: 'None',
    SHA256: 'SHA-256',
    PLAIN: 'Plain',
  },

  GRANT_TYPES: {
    AUTHORIZATION_CODE: 'authorization_code',
  },
};
